var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageWrapper',{attrs:{"name":"campus-resources","navTitle":"Tools And Resources To Further Enable Your Success","navTitleId":"tools-resource-title","routeName":"resource","items":_vm.resources,"backButton":{
        route: _vm.backButton.backRoute,
        label: _vm.backButton.backLabel,
    }},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('router-view',{key:_vm.$route.path})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }